import TableGames from './TableGames';
export default TableGames;
